import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rfid-table-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
